import React from "react";

function PaymentForm() {
  return <div>PaymentForm</div>;
}

export default PaymentForm;
